import Vue from 'vue'
import Vuex from 'vuex'
import DeviceState from './devices'
import UserState from './user'
import TokenState from './token'
import TariffsState from './tariffs'
import ConnectionsState from './connections'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    DeviceState,
    UserState,
    TokenState,
    TariffsState,
    ConnectionsState
  },
  state: {
    allLoaded: false
  },
  getters: {
    allLoaded(state){
      return state.allLoaded
    }
  },
  mutations: {
    allLoad(state){
      if(UserState.state.user != null && DeviceState.state.devices != null 
        && DeviceState.state.deviceTypes.length > 0 && 
        DeviceState.state.subDeviceTypes.length > 0 && 
        DeviceState.state.subjectCreationData != null)
      state.allLoaded = true
    },
    resetState(state){
      state.allLoaded = false
      DeviceState.state.devices = null
      DeviceState.state.deviceTypes = []
      DeviceState.state.subDeviceTypes = []
      DeviceState.state.subjectCreationData = null
      UserState.state.user = null
      TokenState.state.accessToken = null
      TokenState.state.refreshToken = null
      TariffsState.state.tariffs = []
      ConnectionsState.state.connection = null
    },
  },
  actions: {
  }
})
